module.exports = __webpack_public_path__ + "media/svg-new/Fisica-b00b35e3.svg";